import type { GetProductInfoDialogShowMrpStatementProps } from '../api';
import { getProductInfoDialogShowMrpStatement } from '../api';
import { useSWRFetch } from './internal/useSWRFetch';

export const useGetProductInfoDialogShowMrpStatement = ({
  staticApiUrl,
  tenant,
}: GetProductInfoDialogShowMrpStatementProps) =>
  useSWRFetch({
    fallback: false,
    fetcher: async () => getProductInfoDialogShowMrpStatement({ staticApiUrl, tenant }),
    key: [staticApiUrl, tenant],
  });
